export const ROUTES = {
  LANDING: '/',
  PATH_SELECTION: '/path-selection',
  ITEMS: '/items',
  SUBSCRIBE: '/subscribe',
  TIERS: '/choose-your-peace',
  VENDOR: '/vendor',
  SENDER: '/sender',
  RECIPIENT: '/recipient',
  PAYMENT: '/payment',
  PAYMENT_CALLBACK: '/payment-callback',
  CONFIRMATION: '/confirmation',
  OFFERS: '/offers',
  OFFER: '/offers/:slug',
  OFFER_ORDER: '/offers/:slug/order',
  OFFER_CONFIRMATION: '/offers/:slug/confirmation',
  OFFER_MANAGE: '/offers/:slug/manage/:orderId',
} as const;

export type RoutePath = typeof ROUTES[keyof typeof ROUTES];
